import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult } from '../../api'
import { StatusCodes } from '../../http-status-codes'
import { handleFetchError } from 'src/Libs/api/utils'
import { TestRunsModel } from '../models/hardware-tests.model'
import { TestRunsDto } from '../dto/hardware-tests.dto'
import fromDtoToTestRunRecord from '../transformers/from-dto-to-test-run-record-model.transformers'
import fromDtoToTestResultModelTransformer from '../transformers/from-dto-to-test-result.transformers'
import { TestResultDto } from '../dto/hardware-test-result.dto'
import { HardwareTestResultModel } from '../models'
import { FetchTestRunsParams } from './types'

export const fetchTestRuns = async ({ offset, pageSize, authFetch, storageId }: FetchTestRunsParams): Promise<ApiResult<TestRunsModel>> => {
  let searchParams = `?pageSize=${pageSize}&ordering=DESC&orderingColumn=startedAt`

  if (offset) {
    searchParams += `&offset=${offset}`
  }

  try {
    const response = await authFetch<TestRunsDto>({
      path: `hardware-tests/storages/${storageId}/tests/runs${searchParams}`,
      method: 'GET',
      endpoint: process.env.REACT_APP_HARDWARE_TESTS_ENDPOINT,
    })

    if (response.status === StatusCodes.OK) {
      const data = fromDtoToTestRunRecord(response.data)

      return new ApiResult<TestRunsModel>(data)
    }

    return new ApiResult<TestRunsModel>(null, true)
  } catch (error) {
    return handleFetchError<TestRunsModel>(error)
  }
}

export const cancelTest = async (storageId: string | undefined, testRunId: string, authFetch: AuthFetchWithResponse): Promise<ApiResult<void>> => {
  const response = await authFetch<void>({
    path: `hardware-tests/storages/${storageId}/tests/runs/${testRunId}`,
    method: 'PUT',
    endpoint: process.env.REACT_APP_HARDWARE_TESTS_ENDPOINT,
    payload: {},
  })

  if (response.status === StatusCodes.NO_CONTENT) {
    return new ApiResult<void>(null, false)
  }

  return new ApiResult<void>(null, true)
}

export const fetchLatestTestRun = async (
  storageId: string | undefined,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<HardwareTestResultModel>> => {
  try {
    const response = await authFetch<TestResultDto>({
      path: `hardware-tests/storages/${storageId}/tests/runs/latest`,
      method: 'GET',
      endpoint: process.env.REACT_APP_HARDWARE_TESTS_ENDPOINT,
    })

    if (response.status === StatusCodes.OK) {
      const data = fromDtoToTestResultModelTransformer(response.data)

      return new ApiResult<HardwareTestResultModel>(data)
    }

    return new ApiResult<HardwareTestResultModel>(null, true)
  } catch (error) {
    return handleFetchError<HardwareTestResultModel>(error)
  }
}
